"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventDataType = exports.EventDataContext = void 0;
var EventDataContext;
(function (EventDataContext) {
    EventDataContext["prescriptionHandlingAvailable"] = "prescriptionHandlingAvailable";
    EventDataContext["prescriptionReminder"] = "prescriptionReminder";
    EventDataContext["emailAddressEmpty"] = "emailAddressEmpty";
    EventDataContext["fillProfile"] = "fillProfile";
    EventDataContext["generalWelcome"] = "generalWelcome";
    EventDataContext["participatedRegistrationPromotion"] = "participatedRegistrationPromotion";
    EventDataContext["registrationPromotionFulfilled"] = "registrationPromotionFulfilled";
    EventDataContext["registrationPromotionDeclined"] = "registrationPromotionDeclined";
    EventDataContext["prescriptionReqeustStatusChange"] = "prescriptionReqeustStatusChange";
    EventDataContext["medicationReqeustStatusChange"] = "medicationReqeustStatusChange";
    EventDataContext["registrationPromotionGracePeriod"] = "registrationPromotionGracePeriod";
    EventDataContext["registrationPromotionAgreementDeadlineExpired"] = "registrationPromotionAgreementDeadlineExpired";
    EventDataContext["mergeSuccess"] = "mergeSuccess";
    EventDataContext["mergeFailure"] = "mergeFailure";
    EventDataContext["covidSelfTestInfo"] = "covidSelfTestInfo";
    EventDataContext["dailymedNewService"] = "dailymedNewService";
    EventDataContext["healthQuestionsInfo"] = "healthQuestionsInfo";
    EventDataContext["genericMedicamentSubstitutionYes"] = "genericMedicamentSubstitutionYes";
    EventDataContext["genericMedicamentSubstitutionNo"] = "genericMedicamentSubstitutionNo";
    EventDataContext["medicationAvailability"] = "medicationAvailability";
    EventDataContext["dataProtectionRule"] = "dataProtectionRule";
    EventDataContext["doubleCumulusPoints"] = "doubleCumulusPoints";
})(EventDataContext || (exports.EventDataContext = EventDataContext = {}));
var EventDataType;
(function (EventDataType) {
    EventDataType["portalNotification"] = "portalNotification";
})(EventDataType || (exports.EventDataType = EventDataType = {}));
//# sourceMappingURL=events.js.map